// extracted by mini-css-extract-plugin
export default {"container":"ChannelsHeader_container__Y2mQW","nameContainer":"ChannelsHeader_nameContainer__Wk2az","newChatButton":"ChannelsHeader_newChatButton__O5pBo"};